exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tasks-container{display:flex;flex-direction:column;height:100%;width:100%}.tasks-container .tasks-header{width:100%;height:75px;background-color:#fff}.tasks-container .tasks-body{display:flex;flex-direction:row;height:calc(100% - 76px);position:relative}.tasks-container .tasks-body .nav-container{position:relative;width:250px;height:100%;background-color:#222;margin:0}.tasks-container .tasks-body .nav-container.use-project_templates{background-color:gray}.tasks-container .tasks-body .nav-container .footer{background-color:transparent;position:absolute;height:60px;width:246px;bottom:0;left:0}.tasks-container .tasks-body .nav-container .footer .ao-logo{position:absolute;left:24px;bottom:14px;width:28px;height:31px}.tasks-container .tasks-body .nav-container .footer .caption{position:absolute;left:62px;bottom:24px;font-family:Open Sans,sans-serif;font-weight:400;font-size:9px;line-height:10px;color:#8b8b8b;letter-spacing:1px}.tasks-container .tasks-body .detail-container{flex-grow:1;display:flex;background:#f2f4f6;overflow:hidden}.tasks-container .tasks-body .detail-container .restricted-message{display:flex;justify-content:center;align-items:center;height:100%;text-align:center;font-size:20px;color:#8b8b8b;font-family:Open Sans}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/TasksContainer/TasksContainer.scss
// module id = 1856
// module chunks = 0